export enum FeatureFlagId {
  ADD_BANK_ACCOUNTS = 'tempAaSettlementAccounts',
  ADD_NEW_PROCESSING_CHANNEL = 'tempMcrAddNewProcessingChannel',
  ADD_NEW_PROCESSING_URLS = 'tempMcrAddNewProcessingUrl',
  PAYMENT_LIFECYCLE_NOTIFICATIONS = 'tempPaymentLifecycleNotifications',
  APPROVALS_UI = 'tempDashboardApprovalsUi150424',
  AUTHORIZATION_RELAY = 'dashboardIssuingViewAuthrelayTemp',
  BALANCES_NOTIFICATIONS = 'tempBalancesNotifications',
  BALANCES_TEMP = 'tempDashboardBalancesPage',
  BILLING_DESCRIPTORS_MANAGE = 'tempMcrManageBillingDescriptors',
  CENTRALISED_HEADINGS = 'tempDashboardIaHeadings251024',
  CHATBOT = 'tempMerchantCareDashboardSupportBot',
  DARK_MODE = 'tempDarkMode091224',
  DEVELOPER_EXPERIENCE_ACCESS = 'tempMainDevelopers',
  DEVELOPER_EXPERIENCE_ACCESS_GUIDE = 'tempDxGetStartedGuide161122',
  DEVELOPER_EXPERIENCE_ACCESS_LOGS = 'tempDxApiLogsPage09112022',
  DEVELOPER_EXPERIENCE_MIGRATION = 'tempDeveloperExperienceMigration',
  DISPLAY_STAKEHOLDERS = 'tempMcrDisplayStakeholders',
  DYNAMIC_BILLING_DESCRIPTOR_MANAGE = 'tempMcrDynamicBillingDescriptor',
  ENTITY_STRUCTURE = 'tempAccessEntitiesStructure',
  FORWARD_CREDENTIALS = 'tempCredentialsLifecycleForwardDashboard310824',
  IA_NAVIGATION = 'tempEnableIaNavigation',
  IDV_ACCESS = 'tempEnableIdv',
  INTEGRATION_HEALTH_ACCESS = 'tempPaymentPerformanceIntegrationHealth',
  INVOICES = 'tempDashboardInvoicesPage',
  ISSUING_ACCESS = 'dashboardIssuing',
  BUSINESS_ACCOUNT_CARDS = 'dashboardBusinessAccountCards',
  ISSUING_CARD_PRODUCTS = 'dashboardIssuingCardProductsLinkTemp',
  ISSUING_CARD_PROGRAM = 'dashboardIssuingCardProgramLinkTemp',
  LEGACY_ANALYTICS_PAGES = 'enableLegacyAnalyticsPages',
  MULTI_FACTOR_AUTHENTICATION = 'tempMultiFactorAuthentication',
  NETWORK_TOKENS = 'tempCredentialLifecycleNetworkTokensDashboard051124',
  NOTIFICATIONS_SETTINGS_CLIENT_SETTLEMENTS = 'tempClientSettlementsNotificationsSettings201124',
  PAYMENT_INQUIRIES = 'tempDashboardPaymentInquiries',
  PAYMENT_LIFECYCLE = 'tempEnablePaymentsLifecycle',
  PAYMENT_LIFECYCLE_CAPTURES_AND_REFUNDS = 'tempEnablePaymentsLifecycleCapturesAndRefunds',
  PAYMENT_METHODS_MANAGE = 'tempMcrManagePaymentMethods',
  PRISM_NEW_DATA_QUALITY_PAGE = 'tempPrismNewDataQualityPage',
  PROCESSING_URLS_MANAGE = 'tempMcrManageProcessingUrls',
  REMOVE_APPLIER_ROLE = 'tempAaRemoveApplierRole',
  SEGMENTS = 'tempDashboardSegments',
  SETTLEMENTS = 'tempDashboardNewClientSettlementsPage',
  SUPPORT_BOT = 'tempMerchantCareDashboardSupportBot',
  USER_NOTIFICATIONS = 'tempUserNotifications',
  VAULT = 'tempCredentialsLifecycleVaultDashboard',
  VIEW_BUSINESS_DETAILS = 'tempMcrViewBusinessDetails',
  EDIT_BUSINESS_DETAILS = 'tempAaArcSummaryEdit250425',
  VIEW_PROCESSING_CHANNELS = 'tempMcrViewProcessingChannels',
  NEW_AUTH = 'tempSwitchAuthProvider',
  INTEGRATION_HEALTH_PAYLOAD_ANALYSIS = 'tempIntegrationHealthPayloadAnalysis',
  NEW_HEADINGS = 'tempDashboardIaHeadings251024',
  ENABLE_HEAP_ERROR_REPORTING = 'enableHeapErrorReporting',
  EGW_API_LOGS = 'tempApiLogs',
  REPORTS_SFTP_SELF_SERVE = 'tempReportsSelfServeSftp',
  ACCEPTANCE_RATES = 'tempDashboardNewAcceptanceRatesPage',
}
